import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row, DropdownButton, MenuItem, HelpBlock } from 'react-bootstrap';
import { FormActions, DateTimeInput } from '../../../common/components/formControls';
import CentersDropdownList from '../../centers/DropdownList';
import { withTranslation } from 'react-i18next';
import utils from '../../../common/services/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, reset, loading, pristine, t, onSubmit }) => {
	const menuItemInnerStyle = { display: 'block', padding: '10px 20px' };
	const handleReset = () => {
		reset();
		setTimeout(() => handleSubmit());
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit(values => onSubmit({ ...values }))}>
					<Row>
						<Col sm={6}>
							<CentersDropdownList render='field' name='centerId' filter={center => !center.isKindergarten} label={t('CancellationCreditNote_Center')} />
						</Col>
						<Col sm={3}>
							<Field name='startCancellationDate' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodFrom()} placeholder={t('Common_From')} label={t('CancellationCreditNote_CancellationPeriod')} />
						</Col>
						<Col sm={3}>
							<Field name='endCancellationDate' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodTo()} placeholder={t('Common_To')} label='&nbsp;' />
						</Col>
					</Row>
					<FormActions>
						<Button onClick={handleSubmit(values => onSubmit({ ...values }))} disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<DropdownButton title={<span>{t('Common_Export')} <FontAwesomeIcon icon={faAngleDown} /></span>} noCaret disabled={loading} bsStyle='warning'>
							<MenuItem key='Excel' eventKey='Excel' onSelect={handleSubmit(values => onSubmit({ ...values, exportFormat: 'Excel' }))}>
								<span style={menuItemInnerStyle} >{t('Common_ExportToExcel')}</span>
							</MenuItem>
							<MenuItem key='Xero' eventKey='Xero' onSelect={handleSubmit(values => onSubmit({ ...values, exportFormat: 'Xero' }))} >
								<span style={menuItemInnerStyle} >{t('Common_ExportToXeroCSV')}</span>
							</MenuItem>
						</DropdownButton>
						<Button disabled={pristine || loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
					<HelpBlock>{t('Common_ExportHelpText')}</HelpBlock>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'cancellationCreditNoteFilter' })(withTranslation()(Filter));